export function isPasswd(s) {
  // var patrn = /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,16}$/;
  var patrn = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,12}$/
  if (!patrn.exec(s)) return false
  return true
}



// WEBPACK FOOTER //
// ./src/utils/checkHelper.js